module.exports = __webpack_public_path__ + "img/step-one-saliva.243a63df.png";